import WorkshopModal from './WorkshopModal';

export default WorkshopModal;
